import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { ClientTimeclockService } from '../services/client-timeclock.service';
import { debounce, debounceTime, delay, map, mergeMap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SwipeclockIdValidator implements AsyncValidator {
  private clientCode: string;
  constructor(private clientTimeclockService: ClientTimeclockService) {}
  public init(clientCode: string) {
    this.clientCode = clientCode;
  }

  validate(control: AbstractControl<any, any>): Observable<ValidationErrors> {
    if (!this.clientCode) {
      throw new Error('Must initialize validator.');
    }
    if (!control.value) return of(null);
    return of(control.value).pipe(
      mergeMap(val => {
        return this.clientTimeclockService.validateConfig(this.clientCode, val).pipe(
          map(result => {
            if (!result) {
              return { timeclockValidation: true };
            }
            return null;
          })
        );
      })
    );
  }
}
